import * as Yup from 'yup';
import createCampoOsFormModel from './createCampoOsFormModel';

const {
  formField: { name, etiqueta, tipoCampo, opciones, categoria, dependencias, formula },
} = createCampoOsFormModel;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg),
    [etiqueta.name]: Yup.string().required(etiqueta.requiredErrorMsg),
    [tipoCampo.name]: Yup.string().required(tipoCampo.requiredErrorMsg),
    [categoria.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${categoria.requiredErrorMsg}`),

    [dependencias.name]: Yup.lazy((value) => {
      if (Array.isArray(value)) {
        // Multiple
        return Yup.array()
          .of(
            Yup.object().shape({
              value: Yup.string().required(),
              label: Yup.string().required(),
            })
          )
          .min(0, dependencias.requiredErrorMsg);
      }
      // Simple
      return Yup.object()
        .shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
        .nullable()
        .required(dependencias.requiredErrorMsg);
    }),

    [formula.name]: Yup.string().when(dependencias.name, {
      is: (val: any) => {
        // Si es multiple y hay al menos 1 seleccionado
        if (Array.isArray(val)) return val.length > 0;
        // Si es simple y no es null
        return !!val;
      },
      then: (schema) => schema.required(formula.requiredErrorMsg),
      otherwise: (schema) => schema.notRequired(),
    }),

    [opciones.name]: Yup.string().when(tipoCampo.name, {
      is: (value: string) => value === 'select',
      then: (schema) => schema.required(opciones.requiredErrorMsg),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
];
